import { Injectable, EventEmitter } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface Config {
  env: string;
}

@Injectable()
export class ConfigService {
    private static _config: any

    public static get PAGE_SIZE(): number {
        if (this._config != null)
            return this._config.tablePageSize;
    }

    public static get APP_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.appApiUrl;
    }

    public static get APP_SECURITY_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.appSecurityApiUrl;
    }

    public static get LOG_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.logApiUrl;
    }

    public static get IO_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.ioApiUrl;
    }

    public static get STATS_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.statsApiUrl;
    }

    public static get AUTH_API_ENDPOINT(): string {
        if (this._config != null)
            return this._config.authApiUrl;
    }

    public static get VERSION(): string {
        if (this._config != null)
            return this._config.version;
    }

    public static get OIDC_AUTHORITY(): string {
        if (this._config != null)
            return this._config.oidcAuthority;
    }

    public static get OIDC_CLIENT_ID(): string {
        if (this._config != null)
            return this._config.oidcClientId;
    }

    public static get OIDC_REDIRECT_URL(): string {
        if (this._config != null)
            return this._config.oidcRedirectUrl;
    }

    public static get OIDC_POST_LOGOUT_URL(): string {
        if (this._config != null)
            return this._config.oidcPostLogoutUrl;
    }

    public static get OIDC_RESPONSE_TYPE(): string {
        if (this._config != null)
            return this._config.oidcResponseType;
    }

    public static get OIDC_SCOPE(): string {
        if (this._config != null)
            return this._config.oidcScope;
    }

    public static get OIDC_SILENT_CALLBACK_URL(): string {
        if (this._config != null)
            return this._config.oidcSilentCallbackUrl;
    }

    public static get OIDC_METADATA_URL(): string {
        if (this._config != null)
            return this._config.oidcMetadataUrl;
    }

    public static get AUTH_ENDPOINT(): string {
        if (this._config != null)
            return this._config.authUrl;
    }
    
    constructor(private http: HttpClient) {
    }

    configUrl = 'config.json';

    static configLoadedEvent: EventEmitter<any> = new EventEmitter<any>();
    static configLoaded = new AsyncSubject<Boolean>();

    getConfig() {
      return this.http.get(this.configUrl);
    }

    loadConfig() {
        // console.log('current config is ' + ConfigService._config);

        // configLoaded hangs until complete() is called
        // allowing us to wait until config is loaded
        ConfigService.configLoadedEvent.subscribe(() => {
            ConfigService.configLoaded.next(true);
            ConfigService.configLoaded.complete();
        })

        if (ConfigService._config != undefined)
        {   
            ConfigService.configLoadedEvent.emit();
            return Promise.resolve(() => ConfigService._config);
        }
		
		// console.log('loading config from server...');
        return new Promise((resolve) => {
			this.getConfig().subscribe((data: Config) => {
				this.http.get('config.' + data.env + '.json?date=' + new Date().getTime()).subscribe(
					(cfg) => { 
						// console.log("setting config");
						ConfigService._config = cfg;
						ConfigService.configLoadedEvent.emit();
						resolve(true);
					}, // Success path
					error => console.log("Error getting config." + data.env + ".json: " + error) // Error path
				);
			})
        });
    }

    // Returns a promise that only resolves when the config is loaded
    public waitUntilConfigLoaded() : Promise<any> {
        return new Promise(resolve => {
            ConfigService.configLoaded.subscribe(() => {
                resolve();
            })
        })
    }

    // Returns a promise that only resolves when the config is loaded
    public static waitUntilConfigLoaded() : Promise<any> {
        return new Promise(resolve => {
            ConfigService.configLoaded.subscribe(() => {
                resolve();
            })
        })
    }
}